import React from 'react';
import { AppNavigationShell } from './navigation';

interface LayoutProps {
    children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
    return <AppNavigationShell>{children}</AppNavigationShell>;
};
